import * as React from 'react'
import { ReactElement } from 'react'
import { InjuryPanelProps } from './FormContainer'
import { Field, SpinButton } from '@fluentui/react-components'

type Props = InjuryPanelProps & {}

export default function UnfitForWorkPanel(props: Props): ReactElement {
    return (
        <div className={props.styles.formRow}>
            <Field label="Arbeidsongeschiktheid" orientation={props.orientation}>
                <SpinButton min={0} max={100} />
            </Field>
        </div>
    )
}
